"use client";

import { ArrowUpRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Reporting() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const standards = [{
    id: "REP-2024-05",
    title: "Sustainability Impact Review",
    sector: "ESG",
    date: "Jan 2024",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706817/img/sustainability_impact_data.png"
  }, {
    id: "REP-2023-06",
    title: "Supply Chain Resilience Report",
    sector: "Logistics",
    date: "Dec 2023",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706817/img/supply_chain_logistics_report.png"
  }, {
    id: "REP-2023-07",
    title: "Asset Performance Metrics",
    sector: "Operations",
    date: "Dec 2023",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706817/img/asset_performance_dashboard.webp"
  }, {
    id: "REP-2023-08",
    title: "Stakeholder Engagement Data",
    sector: "Governance",
    date: "Nov 2023",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706817/img/stakeholder_engagement_meeting.png"
  }, {
    id: "REP-2023-09",
    title: "Budget Variance Summary",
    sector: "Finance",
    date: "Nov 2023",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706817/img/budget_variance_spreadsheet.png"
  }, {
    id: "REP-2023-10",
    title: "Quality Assurance Protocols",
    sector: "Compliance",
    date: "Oct 2023",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706817/img/quality_assurance_inspection.png"
  }];
  return;
}